import Layout from '@/layout'

const route = {
  path: '/advertisement',
  component: Layout,
  redirect: '/advertisement/index',
  alwaysShow: true, // will always show the root menu
  name: 'advertisement',
  meta: {
    title: '广告投放',
    icon: 'diy-GdGkTbFh',
    roles: [
      'adBroadcact'
    ]
  },
  children: [
    // 头像配置信息
    {
      path: '/messagecenterone/index',
      name: 'Messagecenterone',
      component: () => {
        return import('@/views/messagecenter/index.vue')
      },
      meta: {
        title: '腾讯广告',
        roles: [
          'tencentAd'
        ]
      },
      children: [
        {
          path: '/behavioralsource/index',
          component: () => import('@/views/behavioralsource/index.vue'),
          name: 'Behavioralsource',
          meta: {
            title: '行为源',
            // icon: 'component',
            roles: [
              'ad1.userAction.index'
            ]
          }
        },
        // // 手机列表
        // {
        //   path: '/adaccount/index',
        //   component: () => import('@/views/adaccount/index.vue'),
        //   name: 'Adaccount',
        //   meta: {
        //     title: '账户列表',
        //     // icon: 'component',
        //     roles: [
        //       'scan.getScanPhoneList'
        //     ]
        //   }
        // },
        {
          path: '/personnel/index',
          component: () => import('@/views/personnel/index.vue'),
          name: 'Personnel',
          meta: {
            title: '人群包',
            // icon: 'component',
            roles: [
              'ad1.customAudiences'
            ]
          }
        },
        {
          path: '/advertiserslist/index',
          component: () => import('@/views/advertiserslist/index.vue'),
          name: 'Advertisers',
          meta: {
            title: '广告主绑定列表',
            // icon: 'component',
            roles: [
              'ad1.customAudiences.bind'
            ]
          }
        },
        {
          path: '/behavioralsourcetwo/index',
          component: () => import('@/views/behavioralsourcetwo/index.vue'),
          name: 'Behavioralsourcetwo',
          meta: {
            title: '行为源上报',
            // icon: 'component',
            roles: [
              'ad1.userActionV1.index'
            ]
          }
        },
        {
          path: '/accountnumber/index',
          component: () => import('@/views/accountnumber/index.vue'),
          name: 'Behavioralsourcetwo',
          meta: {
            title: '账号管理',
            // icon: 'component',
            roles: [
              'ad1.account.index'
            ]
          }

        },
        {
          path: '/serviceManagementSet/index',
          component: () => import('@/views/serviceManagementSet/index.vue'),
          name: 'serviceManagementSet',
          meta: {
            title: '企微客服集',
            // icon: 'component',
            roles: [
              'api.ad_corp.adGroupSetList'
            ]
          }
        },
        {
          path: '/servicemanagement/index',
          component: () => import('@/views/serviceManagement/index.vue'),
          name: 'Servicemanagement',
          meta: {
            title: '企微客服组',
            // icon: 'component',
            roles: [
              'api.ad_corp.getCorpCsGroupList'
            ]
          }
        },
        {
          path: '/wecomlinkcustomerservice/index',
          component: () => import('@/views/wecomlinkCustomerservice/index.vue'),
          name: 'wecomlinkCustomerservice',
          meta: {
            title: '企微客服',
            // icon: 'component',
            roles: [
              'api.ad_corp.getWechatCorpUser'
            ]
          }
        }
      ]
    },
    {
      path: '/iQiyi/index',
      name: 'Messagecenterone',
      component: () => {
        return import('@/views/messagecenter/index.vue')
      },
      meta: {
        title: '推广链接',
        roles: [
          'iqiyi'
        ]
      },
      children: [
        {
          path: '/miniservice/index',
          component: () => import('@/views/miniservice/index.vue'),
          name: 'Miniservice',
          meta: {
            title: '小程序推广连接',
            // icon: 'component',
            roles: [
              'promotion_link'
            ]
          }
        },
        {
          path: '/wechatTemplate/index',
          component: () => import('@/views/wechatTemplate/index.vue'),
          name: 'WechatTemplate',
          meta: {
            title: '延时消息模板',
            // icon: 'component',
            roles: [
              'delayed_msg_template'
            ]
          }
        },
        {
          path: '/redenvelope/index',
          component: () => import('@/views/redenvelope/index.vue'),
          name: 'Redenvelope',
          meta: {
            title: '红包小程序推广链接',
            // icon: 'component',
            roles: [
              'promotion_link_v2'
            ]
          }
        },
        {
          path: '/aqiiservice/index',
          component: () => import('@/views/aqiiservice/index.vue'),
          name: 'Aqiiservice',
          meta: {
            title: 'H5推广连接',
            // icon: 'component',
            roles: [
              'static_html_link'
            ]
          }
        },
        {
          path: '/messagecenter/index',
          component: () => import('@/views/messagecenter/index.vue'),
          name: 'messagecenter'
        }
      ]
    }

  ]
}

export default route
